import {LabelWithParam} from '@shared/model/label-with-param.interface';
import {AppRouteEnum} from '@shared/module/menu/model';
import {PermissionType} from "@shared/model/permission.type";

export interface MenuAction {
  icon?: string;
  title: string;
  link?: AppRouteEnum;
  type?: MenuActionType;
  confirmMessage?: LabelWithParam;
  titleMessage?: LabelWithParam;
}

export interface MenuActionGroup {
  title: string;
  color: string;
  actions: MenuAction[];
}

export enum MenuActionType {
  ADD = 'ADD',
  LIST = 'LIST',
  UPDATE = 'UPDATE',
  DELETE = 'DELETE',
  SOFTDELETE = 'SOFTDELETE',
  ROLLBACK = 'ROLLBACK',
  ERASE = 'ERASE',
  DETAIL = 'DETAIL',
  DUPLICATE = 'DUPLICATE',
  HELP = 'HELP',
  ADDFILE = 'ADDFILE',
  ADDPARAMETER = 'ADDPARAMETER'
}

export function menuActionRelatedPermission(menuActionType: MenuActionType): PermissionType {
  if (menuActionType === MenuActionType.ADD
    || menuActionType === MenuActionType.ADDFILE
    || menuActionType === MenuActionType.DUPLICATE
    || menuActionType === MenuActionType.ADDPARAMETER) {
    return 'create';
  }

  if (menuActionType === MenuActionType.LIST
    || menuActionType === MenuActionType.HELP
    || menuActionType === MenuActionType.DETAIL) {
    return 'read';
  }

  if (menuActionType === MenuActionType.UPDATE) {
    return 'update';
  }

  return 'delete';
}
